"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4331],{

/***/ 58204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layouts_Main; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/Layouts/Main/Desktop/index.tsx + 5 modules
var Desktop = __webpack_require__(23501);
// EXTERNAL MODULE: ./components/Layouts/TopBanner/index.tsx + 2 modules
var TopBanner = __webpack_require__(33336);
// EXTERNAL MODULE: ./components/Layouts/TopBanner/useCheckOverPeriod.ts
var useCheckOverPeriod = __webpack_require__(91378);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/Layouts/Main/Mobile/Footer/Pairy/index.tsx






var Pairy = function Pairy() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    direction: "column",
    gap: 16,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      href: 'https://salesclue.io',
      passHref: true,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
          src: "/images/salesclue_logo_white_alpha.png",
          width: 133,
          height: 31,
          priority: true
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("address", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        as: "p",
        color: "zinc_400",
        variant: "xs-medium",
        children: ["\uC8FC\uC2DD\uD68C\uC0AC \uB0B4\uB7EC\uD2F0\uBE0C", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uB300\uD45C\uC774\uC0AC: \uAE40\uC778\uAE30", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uC0AC\uC5C5\uC790\uBC88\uD638 : 703-88-00878 l \uD1B5\uC2E0\uD310\uB9E4\uC5C5 \uC2E0\uACE0\uBC88\uD638 : \uC81C 2023-\uC11C\uC6B8\uAC15\uB0A8-04677 \uD638", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uC8FC\uC18C: \uC11C\uC6B8\uD2B9\uBCC4\uC2DC \uC131\uB3D9\uAD6C \uC131\uC218\uC77C\uB85C 10\uAE38 12, 406, 408\uD638 (\uC131\uC218\uB3D92\uAC00, \uC131\uC218\uC528\uC5D0\uD504\uD0C0\uC6CC(\uC131\uC218CF-TOWER))", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "Copyright @ 2025 SalesClue"]
      })
    })]
  });
};

/* harmony default export */ var Footer_Pairy = (Pairy);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/Layouts/Main/Mobile/Footer/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var Wrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("footer",  true ? {
  target: "ep7kgp52"
} : 0)("padding:96px 180px;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_900;
}, ";" + ( true ? "" : 0))));
var InnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ep7kgp51"
} : 0)( true ? {
  name: "su8agc",
  styles: "width:1080px"
} : 0);
var LinkText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "ep7kgp50"
} : 0)( true ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : 0);
;// CONCATENATED MODULE: ./components/Layouts/Main/Mobile/Footer/Sites/index.tsx



var sites = [{
  isInternal: false,
  href: 'https://salesclue.io/blog',
  text: '세일즈클루 블로그'
}, {
  isInternal: false,
  href: 'https://docs.salesclue.io/',
  text: '사용 가이드'
}, {
  isInternal: false,
  href: 'https://codestates.career.greetinghr.com/home',
  text: '채용 정보'
}, {
  isInternal: false,
  href: 'https://codestates.notion.site/salesclue-privacy',
  text: '개인정보 처리 방침'
}, {
  isInternal: false,
  href: 'https://codestates.notion.site/salesclue-policy',
  text: '이용 약관'
}];

var Sites = function Sites() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
    children: sites.map(function (_ref, index) {
      var href = _ref.href,
          text = _ref.text,
          isInternal = _ref.isInternal;

      if (isInternal) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: href,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkText, {
              variant: "sm-medium",
              color: "zinc_200",
              marginTop: index === 0 ? 0 : 16,
              children: text
            })
          })
        }, text);
      }

      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          href: href,
          target: "_blank",
          rel: "noreferrer noopener nofollow",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkText, {
            variant: "sm-medium",
            color: "zinc_200",
            marginTop: index === 0 ? 0 : 16,
            children: text
          })
        })
      }, text);
    })
  });
};

/* harmony default export */ var Footer_Sites = (Sites);
;// CONCATENATED MODULE: ./components/Layouts/Main/Mobile/Footer/index.tsx






var Footer = function Footer() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    gap: 32,
    justifyContent: "center",
    backgroundColor: "zinc_900",
    padding: {
      x: 16,
      y: 96
    },
    direction: "column",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Stack */.Kq, {
      gap: 16,
      direction: "column",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_Pairy, {})
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* FlexItem */.B5, {
        flexGrow: 1,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_Sites, {})
      })
    })]
  });
};

/* harmony default export */ var Mobile_Footer = (Footer);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./constants/zIndex.ts
var zIndex = __webpack_require__(90122);
;// CONCATENATED MODULE: ./components/Layouts/Main/Mobile/Header/index.styles.ts


function index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var FlexWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e13paegx5"
} : 0)("z-index:", zIndex/* Z_INDEX.layoutHeader */.k.layoutHeader, ";top:0;border-bottom:1px solid #e4e4e7;" + ( true ? "" : 0));
var DrawerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e13paegx4"
} : 0)( true ? {
  name: "1jhkypy",
  styles: "top:0;left:0;width:100%;height:100vh;background:rgb(63 63 70 / 25%)"
} : 0);
var DrawerContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e13paegx3"
} : 0)("top:0;left:0;width:275px;height:100vh;padding:16px;border-radius:0 8px 8px 0;box-shadow:", function (_ref) {
  var theme = _ref.theme;
  return theme.elevation.md;
}, ";" + ( true ? "" : 0));
var MenuWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e13paegx2"
} : 0)("&.is-active{background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.skyblue_50;
}, ";border-radius:4px;color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.skyblue_500;
}, ";}" + ( true ? "" : 0));
var SubMenuWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(Flex,  true ? {
  target: "e13paegx1"
} : 0)("&.is-active{background-color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.skyblue_50;
}, ";border-radius:4px;color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.skyblue_500;
}, ";}" + ( true ? "" : 0))));
var Li = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("li",  true ? {
  target: "e13paegx0"
} : 0)("padding:8px 16px;color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.zinc_400;
}, ";cursor:pointer;transition:color 0.2s ease-in-out;&.active{color:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.skyblue_400;
}, ";}&:hover{color:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.skyblue_400;
}, ";}" + ( true ? "" : 0))));
;// CONCATENATED MODULE: ./components/Layouts/Main/Mobile/Header/index.tsx










var drawerMenu = [{
  url: '/login',
  label: '홈',
  isExternal: false
}, {
  url: 'https://blog.pairy.co/',
  label: '블로그',
  isExternal: true
}, {
  url: 'https://docs.salesclue.io/',
  label: '가이드',
  isExternal: true
}, {
  url: 'https://slashpage.com/b2b-serious-content',
  label: '콘텐츠 함께 만들기',
  isExternal: true
}];

var Header = function Header() {
  var _useState = (0,react.useState)(false),
      isDrawerOpened = _useState[0],
      setDrawerOpened = _useState[1];

  var router = (0,next_router.useRouter)();
  var pathname = router.pathname;

  var moveLinkUrl = function moveLinkUrl(_ref) {
    var url = _ref.url,
        _ref$isExternal = _ref.isExternal,
        isExternal = _ref$isExternal === void 0 ? false : _ref$isExternal;

    if (isExternal && window) {
      window.open(url);
      return;
    }

    router.push(url);
  };

  var handleDrawer = function handleDrawer(event) {
    event.stopPropagation();
    document.body.style.overflow = isDrawerOpened ? 'unset' : 'hidden';
    setDrawerOpened(function (prev) {
      return !prev;
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FlexWrapper, {
    as: "header",
    position: "fixed",
    direction: "column",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopBanner/* default */.ZP, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
      justifyContent: "center",
      padding: {
        y: 12,
        x: 16
      },
      backgroundColor: "white",
      alignItems: "center",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* FlexItem */.B5, {
        flexBasis: "50%",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 19,
          alignItems: "center",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: "ph:list",
            size: 24,
            onClick: handleDrawer
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
            type: "button",
            onClick: function onClick() {
              moveLinkUrl({
                url: 'https://salesclue.io'
              });
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
              src: "/images/salesclue_logo_white_alpha.png",
              width: 116,
              height: 27,
              priority: true
            })
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* FlexItem */.B5, {
        flexBasis: "50%",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 8,
          justifyContent: "flex-end",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: "/login",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
              children: "\uB85C\uADF8\uC778"
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: "/signup",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
              variant: "zinc_700_fill",
              children: "\uD68C\uC6D0\uAC00\uC785"
            })
          })]
        })
      }), isDrawerOpened && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DrawerWrapper, {
          position: "absolute",
          onClick: handleDrawer,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DrawerContent, {
            position: "absolute",
            backgroundColor: "white",
            direction: "column",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
              justifyContent: "space-between",
              padding: {
                y: 8,
                x: 16
              },
              marginBottom: 16,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "lg-semibold",
                children: "\uBA54\uB274"
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
                icon: "ph:x",
                size: 19,
                onClick: handleDrawer
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Stack */.Kq, {
              gap: 8,
              direction: "column",
              children: drawerMenu.map(function (menu) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuWrapper, {
                    padding: {
                      y: 8,
                      x: 16
                    },
                    className: pathname === menu.url ? 'is-active' : '',
                    onClick: function onClick() {
                      return moveLinkUrl({
                        isExternal: menu.isExternal,
                        url: menu.url
                      });
                    },
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                      variant: "lg-semibold",
                      color: menu.label === '콘텐츠 함께 만들기' ? 'viridian_400' : 'zinc_500',
                      children: menu.label
                    })
                  }, menu.url)
                });
              })
            })]
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var Mobile_Header = (Header);
;// CONCATENATED MODULE: ./components/Layouts/Main/Mobile/index.styles.ts

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e17909k70"
} : 0)("width:", function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth ? '100%' : '1080px';
}, ";padding-top:", function (_ref2) {
  var isSetPaddingTop = _ref2.isSetPaddingTop,
      isBannerVisible = _ref2.isBannerVisible;
  return isSetPaddingTop ? isBannerVisible ? '80px' : '60px' : '0px';
}, ";margin:0 auto;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/Layouts/Main/Mobile/index.tsx









var MainLayout = function MainLayout(_ref) {
  var children = _ref.children,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      _ref$isSetPaddingTop = _ref.isSetPaddingTop,
      isSetPaddingTop = _ref$isSetPaddingTop === void 0 ? true : _ref$isSetPaddingTop,
      className = _ref.className;

  var _useCheckOverPeriod = (0,useCheckOverPeriod/* default */.Z)({
    targetDate: TopBanner/* TARGET_DATE */.Tm
  }),
      isValid = _useCheckOverPeriod.isValid;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mobile_Header, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Main, {
      className: className,
      fullWidth: fullWidth,
      isSetPaddingTop: isSetPaddingTop,
      isBannerVisible: isValid,
      children: children
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mobile_Footer, {})]
  });
};

/* harmony default export */ var Mobile = (MainLayout);
;// CONCATENATED MODULE: ./components/Layouts/Main/index.tsx






var Main_Main = function Main(_ref) {
  var children = _ref.children,
      tabChangeHandler = _ref.tabChangeHandler,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;

  var _useState = (0,react.useState)(false),
      isMounted = _useState[0],
      setIsMounted = _useState[1];

  (0,react.useEffect)(function () {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
  }

  if (isMobile) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mobile, {
      fullWidth: true,
      tabChangeHandler: tabChangeHandler,
      children: children
    });
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Desktop/* default */.Z, {
    fullWidth: true,
    children: children
  });
};

/* harmony default export */ var Layouts_Main = (Main_Main);

/***/ }),

/***/ 33336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Tm": function() { return /* binding */ TARGET_DATE; },
  "ZP": function() { return /* binding */ Layouts_TopBanner; }
});

// UNUSED EXPORTS: DESCRIPTION

// EXTERNAL MODULE: ../../node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(17160);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/Layouts/TopBanner/LineBanner/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "egvbv9b0"
} : 0)( true ? {
  name: "1p3qk0r",
  styles: "&:hover{cursor:pointer;}"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/Layouts/TopBanner/LineBanner/index.tsx






var LineBanner = function LineBanner(_ref) {
  var link = _ref.link,
      description = _ref.description,
      isMobile = _ref.isMobile,
      isOpenNewTab = _ref.isOpenNewTab;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    alignItems: "center",
    justifyContent: "center",
    gap: 16,
    backgroundColor: "skyblue_700",
    padding: {
      y: isMobile ? 16 : 8
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-medium",
      color: "skyblue_100",
      children: description
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: isOpenNewTab ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: link.url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkWrapper, {
            gap: 4,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-semibold",
              color: "white",
              children: link.content
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
              icon: "ph:caret-right",
              size: 14,
              color: "white"
            })]
          })
        })
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: link.url,
        replace: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkWrapper, {
            gap: 4,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-semibold",
              color: "white",
              children: link.content
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
              icon: "ph:caret-right",
              size: 14,
              color: "white"
            })]
          })
        })
      })
    })]
  });
};

/* harmony default export */ var TopBanner_LineBanner = (LineBanner);
// EXTERNAL MODULE: ./components/Layouts/TopBanner/useCheckOverPeriod.ts
var useCheckOverPeriod = __webpack_require__(91378);
;// CONCATENATED MODULE: ./components/Layouts/TopBanner/index.tsx




var TARGET_DATE = '2023-11-12T23:59:59';
var DESCRIPTION = '파일을 열어보기 전 이메일을 입력받아보세요';

var TopBanner = function TopBanner() {
  var isMobile = (0,react_responsive.useMediaQuery)({
    maxWidth: 767
  });

  var _useCheckOverPeriod = (0,useCheckOverPeriod/* default */.Z)({
    targetDate: TARGET_DATE
  }),
      isValid = _useCheckOverPeriod.isValid;

  if (!isValid) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopBanner_LineBanner, {
    description: DESCRIPTION,
    link: {
      content: '더 알아보기',
      url: 'https://salesclue.gitbook.io/guide/features/collect_email'
    },
    isMobile: isMobile,
    isOpenNewTab: true
  });
};

/* harmony default export */ var Layouts_TopBanner = (TopBanner);

/***/ }),

/***/ 91378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var useCheckOverPeriod = function useCheckOverPeriod(_ref) {
  var targetDate = _ref.targetDate;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isValid = _useState[0],
      setIsValid = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var currentTime = new Date();
    var targetTime = new Date(targetDate);
    setIsValid(currentTime < targetTime);
  }, []);
  return {
    isValid: isValid
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useCheckOverPeriod);

/***/ }),

/***/ 65118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ CLIENT_IDENTITY_REQUIRED_MESSAGE; },
/* harmony export */   "R": function() { return /* binding */ FORM_VALIDATIONS; }
/* harmony export */ });
var FORM_VALIDATIONS = {
  email: {
    pattern: {
      value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
      message: '잘못된 이메일 주소입니다.'
    },
    required: '이메일을 입력해주세요.'
  },
  hyperLink: {
    pattern: {
      value: /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\\+.~#?&\\/=]*)$/,
      message: '올바른 URL 형식이 아닙니다. http:// 또는 https:// 로 시작하는 링크를 입력하세요.'
    },
    required: '링크를 입력해주세요.'
  },
  memo: {
    maxLength: {
      value: 500,
      message: '메모는 500자 이내로 입력해주세요.'
    }
  }
};
/**
 * 고객 등록·수정의 신원 필수 조건 안내 문구.
 *
 * 서버 정책이 "고객명·연락처·회사명 중 하나" → "고객명·연락처·회사명·이메일 중 하나"로
 * 완화되면서, 같은 조건을 3개 화면이 제각각 표기하던 것을 한 곳으로 모은다.
 * 표기 순서는 폼의 필드 배치 순서를 따른다.
 */

var CLIENT_IDENTITY_REQUIRED_MESSAGE = '고객 이름, 회사명, 연락처, 이메일 중 하나는 필수입니다.';

/***/ })

}]);